import React from "react";
import {FinLossTable} from "../components/FinLossTable";

export function Finance({fullData}) {
	return(
		<FinLossTable data={fullData}/>
	);
}
